$(document).ready(function(){
                
  
  				// Flexslider
                $(window).load(function(){
                    var slider = $('.flexslider');
                    slider.flexslider({
                        animation: "slide", 
                      	slideshow: true,
                        animationDuration: 700,
                        slideshowSpeed: 6000,
                        animation: "fade"
                    });

                    // #Next / #Prev
                    $('.lft-sl').click(function(){$(".prev").trigger('click'); });
                    $('.rht-sl').click(function(){ $('.next').trigger("click"); });
                });
  
  				$('#bxslider').bxSlider({
                  minSlides: 2,
                  maxSlides: 2,
                  slideWidth: 175,
                  slideMargin: 0,  
                  nextSelector: '.next', 
                  prevSelector: '.previous', 
                  infiniteLoop: false,
  				  hideControlOnEnd: true
                });
  				$('#bxslider2').bxSlider({
                  minSlides: 2,
                  maxSlides: 2,
                  slideWidth: 175,
                  slideMargin: 0,  
                  nextSelector: '.next2', 
                  prevSelector: '.previous2', 
                  infiniteLoop: false,
  				  hideControlOnEnd: true, 
                  nextText: "", 
                  prevText: ""
                });
  
  // Feature Hover Effect
  $('.uni-featured-products li a').each(function(i, e){
    var _this = $(this);
    _this.hover(
      function(){
        $(this).find('img').css({'opacity':'.6'});
        $(this).find('h2').css({'color':'#C61F17'});
        
      }, 
      function(){
        $(this).find('img').css({'opacity':'1'});
        $(this).find('h2').css({'color':'#FFFFFF'});
      }
    );
  });
  
  
  // Feature List Products
  $('#bxslider li a, #bxslider2 li a').each(function(i, e){
    var _this = $(this);
    _this.hover(
      function(){
        $(this).find('img').css({'opacity':'.6'});
        $(this).find('h3').css({'color':'#E82028'});
      }, 
      function(){
        $(this).find('img').css({'opacity':'1'});
        $(this).find('h3').css({'color':'#FFFFFF'});
      }
    );
  });
  
  // Footer Links Hover Effect
  $('.footer-widget a').hover(
    function(){
      $(this).css({'color':'#E82028'});
    }, 
    function(){
      $(this).css({'color':'#FFFFFF'});
    }
  );
  
  // Send Button
  $('.cst-request ul li input[type="button"], .cst-request ul li input[type="submit"], #add-to-cart, .share li a, .applause li a, .follow li a, .nav-login, .nav-cart').hover(
    function(){ $(this).css({'opacity':'.6'}); }, 
    function(){ $(this).css({'opacity':'1'}); }
  );
  // Send Button
  $('.share li a, .applause li a, .follow li a').hover(
    function(){ $(this).find('span').css({'opacity':'.6'}); }, 
    function(){ $(this).find('span').css({'opacity':'1'}); }
  );
  
  
      
  
  if( $.browser.msie ){
    $('.nav-body ul li:eq(3) a, .nav-body ul li:eq(4) a').css({'background':'none'});
  }
                
});